export default "__VITE_ASSET__CztYBbr5__"